import { Group, UserFull } from '@wellesley/openapi'
import { ProfileResult } from '../../../common/components/results/ProfileResult'
import {
  SearchData,
  SearchResultItemWithType,
} from '../../../common/types/search'
import { GroupWrapper } from '../../../common/components/GroupWrapper'
import { GroupResult } from '../../../common/components/results/GroupResult'
import { TagResult } from '../../../common/components/results/TagResult'

type SearchResultsProps = {
  data: SearchData
  onItemClick: (item: SearchResultItemWithType) => void
  searchInput?: string
  groupName?: string
}

export const SearchResults = ({
  data,
  onItemClick,
  searchInput,
  groupName,
}: SearchResultsProps) => {
  return (
    <div className="flex flex-col ">
      {(data.tags || []).length > 0 && (
        <GroupWrapper>
          {(data.tags || []).slice(0, 4).map((tag: string) => (
            <TagResult
              key={tag}
              tag={tag}
              onItemClick={(tagName) =>
                onItemClick({ type: 'tag', data: tagName })
              }
              searchQuery={searchInput}
              groupName={groupName}
            />
          ))}
        </GroupWrapper>
      )}

      {(data.users || []).length > 0 && (
        <GroupWrapper>
          {(data.users || []).slice(0, 8).map((user: UserFull) => (
            <ProfileResult
              key={user.id}
              profile={user}
              onItemClick={() => onItemClick({ type: 'user', data: user })}
              searchQuery={searchInput}
            />
          ))}
        </GroupWrapper>
      )}

      {(data.groups || []).length > 0 && (
        <GroupWrapper>
          {(data.groups || []).slice(0, 8).map((group: Group) => (
            <GroupResult
              key={group.groupId}
              group={group}
              onItemClick={() => onItemClick({ type: 'group', data: group })}
            />
          ))}
        </GroupWrapper>
      )}
    </div>
  )
}
